import React, { ComponentProps } from 'react';

import { useOptionalUser } from '@adsk/alloy-provider';
import TopNavigation from '@adsk/alloy-top-navigation';

type ConnectedTopNavigationOptionalUserProps = {
  onLogout?: () => void;
};

/**pa
 * This component renders TopNavigation based on optional user - means the user can be logged in or logged out.
 *
 * @param onLogout
 * @return {*}
 * @constructor
 */
const ConnectedTopNavigationOptionalUser: React.FC<
  ConnectedTopNavigationOptionalUserProps
> = ({ onLogout }) => {
  const { data: user, loading } = useOptionalUser();
  const extraProps: {
    user?: ComponentProps<typeof TopNavigation>['user'];
  } = {};

  if (loading || user) {
    extraProps.user = user;
  }

  return (
    <TopNavigation
      logo
      login
      isProductRequired
      onLogout={onLogout}
      showSubscriptionsModal
      {...extraProps}
    />
  );
};

export default ConnectedTopNavigationOptionalUser;
